<section class="section breadcrumbs-custom">
    <div class="breadcrumbs-custom-main bg-image bg-employerlist">
        <div class="container">
            <h3 id="textInImage" class="breadcrumbs-custom-title">Θέσεις Εργασίας</h3>
        </div>
    </div>
    <div class="breadcrumbs-custom-aside">
        <div class="container">
            <ul class="breadcrumbs-custom-path">
                <li><a routerLink="/home">Αρχική</a></li>
                <li><a [routerLink]="['/employer/profile', authService.getCompanyId()]">Εταιρεία</a></li>
                <li class="active"> Θέσεις Εργασίας</li>
            </ul>
        </div>
    </div>
</section>

<section>
    <div class="container mainSection">
        <app-alert-message *ngIf="companyActivationStatus === 'pending' || companyActivationStatus === 'disapproved'" [alertOption]="alertOptionForActivationStatus"></app-alert-message>
        <form (ngSubmit)="getEmployerFilteredList()" [formGroup]="jobListForm" *ngIf="metadata$ | async as metadata">
            <div class="row">
                <div id="dropDown" class="col-xs-12 col-sm-6 col-md-4">
                    <select (change)="dropDownSelectedOption($event.target.value)" formControlName="jobPosts" style="width: 100%;" name="candidates" class="custom-select">
                        <option value="published">Δημοσιευμένες Θέσεις Εργασίας</option>
                        <option value="draft">Αποθηκεύμενες Θέσεις Εργασίας</option>
                        <option value="closed">Αποσυρμένες Θέσεις Εργασίας</option>
                        <option value="all" selected>Όλες οι Θέσεις Εργασίας</option>
                    </select>
                    <p style="padding-left: 10px;" *ngIf="totalElements>0"> Βρέθηκαν {{totalElements}} Θέσεις Εργασίας
                    </p>
                    <p *ngIf="totalElements==0"> Δεν βρέθηκαν Θέσεις Εργασίας</p>
                </div>
                <div>
                    <br />
                    <p style="padding-left: 10px;" *ngIf="totalElements>0">
                    </p>
                    <p *ngIf="totalElements==0"></p>
                </div>
            </div>
            <div class="row flex-row-reverse">
                <!-- search with filters -->
                <div class="col-md-4 col-xs-12 col-sm-12">
                    <div class="filters-background">
                        <p class="heading-8">αναζήτηση με φιλτρα
                            <button *ngIf="isFiltered" class="btn btn-link" type="reset" (click)="discardfilters()">Ακύρωση
                            όλων</button>
                        </p>
                        <hr>
                        <br />
                        <label for="jobtitle">Με βάση τον Τίτλο Θέσης Εργασίας</label>
                        <br />
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span style="background-color: white;" class="input-group-text"><span
                                    class="icon fl-bigmug-line-search74"></span></span>
                            </div>
                            <input formControlName="title" style="height: calc(3rem + 2px); width: 80%; font-size: 0.9rem" type="text" class="form-control" placeholder="πχ. Software Engineer" id="jobtitle">
                        </div>
                        <br />
                        <label for="location">Με βάση την Περιοχή</label>
                        <br />
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span style="background-color: white;" class="input-group-text">
                                <i class="icon fl-bigmug-line-big104"></i>
                            </span>
                            </div>
                            <select id="location" formControlName="locationId" name="candidates" style="height: calc(3rem + 2px);" class="custom-select">
                            <option value="{{location.id}}" *ngFor="let location of locations">{{location.text}}
                            </option>
                        </select>
                        </div>
                        <button id="searchButton" class="button button-lg button-primary" type="submit">Αναζήτηση</button>
                    </div>
                </div>
                <div class="col-md-8 col-xs-12 col-sm-12">
                    <div class="table-responsive">
                        <table *ngIf="items" id="table" class="table-striped">
                            <tr class="rows tr-height tr-break" ngDefaultControl [attr.data-item-value]="content.title" *ngFor="let content of items">

                                <td style="width: 26%;" class="jobRow">
                                    <article class="">
                                        <div class="">
                                            <h6 id="jobTitle">
                                                <a [routerLink]="['/job-details', content.uuid]" *ngIf="content.title && content.title.length>30" placement="top-left" ngbTooltip={{content.title}}>{{content.title.substr(0, 30)}}...</a>
                                                <a [routerLink]="['/job-details', content.uuid]" *ngIf="content.title && content.title.length<=30">{{content.title}}</a>
                                            </h6>
                                            <p style="margin-top:3px">{{content.employmentTypesName}} </p>
                                        </div>
                                    </article>
                                </td>

                                <td style="width: 20%;" class="jobRow">
                                    <span class="icon mdi mdi-map-marker icons"></span><span>{{content.location_name}}</span>
                                    <br />
                                    <span *ngIf="content.expiration_date"><span
                                            class="icon mdi mdi-calendar-clock icons"></span>
                                    <span> Ημ/νία λήξης:</span>
                                    <br>
                                    <span style="margin: 10px;">{{content.expiration_date|date: 'mediumDate'}}</span></span>
                                </td>

                                <td style="width: 20%;" style="text-align: center;" class="jobRow table-job-listing-badge">
                                    <div *ngIf="content.status==='closed'">
                                        <span class="badge badge-secondary">ΑΠΟΣΥΡΘΗΚΕ</span>
                                        <br />
                                    </div>
                                    <span *ngIf="content.status==='draft'" class="badge badge-undefined">ΑΠΟΘΗΚΕΥΜΕΝΗ</span>
                                    <div *ngIf="content.status==='published'">
                                        <span class="badge badge-season">ΔΗΜΟΣΙΕΥΜΕΝΗ</span>
                                    </div>
                                </td>

                                <td style="width: 14%;" *ngIf="content.applications!=0; else zeroApplications" class="jobRow pointer">
                                    <a [routerLink]="['/employers/applied/candidates', content.uuid, this.authService.getCompanyId()]"><span class="icon icon-default text-primary mdi mdi-file-document"></span><span placement="top" ngbTooltip="Δες τις αιτήσεις">{{content.applications}}
                                        αιτήσεις</span></a>
                                </td>

                                <ng-template #zeroApplications>
                                    <td class="jobRow">
                                        <span class="icon icon-default text-primary mdi mdi-file-document"></span>{{content.applications}} αιτήσεις
                                    </td>
                                </ng-template>

                                <!-- icons -->
                                <td style="width: 5%;" class="jobRow">
                                </td>
                                <td style="width: 5%;" class="jobRow">
                                    <i (click)="editJob(content.uuid)" placement="top" ngbTooltip="Επεξεργασία ανάρτησης" class="fa-edit edit normalfont"></i>
                                </td>
                                <td style="width: 5%;" class="jobRow">
                                    <i *ngIf="content.status!=='published'" placement="top" ngbTooltip="Δημοσίευση ανάρτησης" (click)="openModalForIcon(content.uuid, 'published')" class="share_icon fa-share-square-o publish normalfont"></i>
                                    <i *ngIf="content.status==='published'" placement="top" ngbTooltip="Απόσυρση από δημοσιεύση" (click)="openModalForIcon(content.uuid, 'closed')" class="fa fa-archive archive_icon notPublish normalfont"></i>
                                </td>
                                <td style="width: 5%;" class="jobRow">
                                    <i *ngIf="content.status==='draft' || (content.status==='closed' && content.applications===0)" placement="top" ngbTooltip="Διαγραφή ανάρτησης" (click)="openModalForIcon(content.uuid, 'delete')" class="fas fa-trash text-danger delete normalfont"></i>
                                </td>
                            </tr>
                        </table>

                    </div>

                    <div class="pagination-outer text-center">
                        <!-- pagination -->
                        <app-pagination-bs [items]="allJobs" [pageSize]="pageSize" (changePage)="onChangePage($event)"></app-pagination-bs>
                    </div>
                </div>

            </div>
        </form>
    </div>
</section>

<!-- pubilsh job modal -->
<div class="modal fade" id="publishJobModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Δημοσίευση Ανάρτησης</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                Θέλετε να δημοσιεύσετε την ανάρτηση;
            </div>
            <div class="modal-footer">
                <button type="button" (click)="submitModalForIcons(option)" class="btn btn-primary">Δημοσίευση</button>
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Ακύρωση</button>
            </div>
        </div>
    </div>
</div>

<!-- close job modal -->
<div class="modal fade" id="iconModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{headerMessage}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {{bodyMessage}}
            </div>
            <div class="modal-footer">
                <button type="button" (click)="submitModalForIcons(option)" class="btn btn-primary">{{footerMessage}}</button>
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Ακύρωση</button>
            </div>
        </div>
    </div>
</div>

<!-- post job modal -->
<div class="modal fade" id="postJobModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <h5 class="modal-title" id="exampleModalLabel">Δημοσίευση Ανάρτησης</h5>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                Είστε σίγουρος ότι θέλετε να δημοσιεύσετε την ανάρτηση;
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-cancel" data-dismiss="modal">Ακύρωση</button>
                <button type="button" (click)="submitModalForIcons(option)" class="btn btn-primary">Επιβεβαίωση</button>
            </div>
        </div>
    </div>
</div>